import { Descriptions } from "@/components/v2";
import { type DescriptionsProps, Popconfirm, Space } from "antd";
import { Link } from "react-router-dom";
import { ExternalWebhook } from "@rumble-it/common-lib/types/models/ExternalWebhook.interface";
import { UseMutationResult } from "@tanstack/react-query";
import { Button, Card } from "@rumbledirect/ui";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

interface ExternalWebhookDetailCardProps {
  externalWebhook: ExternalWebhook | undefined;
  isLoading?: boolean;
  deleteMutation?: UseMutationResult<null, Error, void, unknown>;
}

export const ExternalWebhookDetailCard = ({
  externalWebhook,
  isLoading,
  deleteMutation,
}: ExternalWebhookDetailCardProps) => {
  const items: DescriptionsProps["items"] = [
    {
      label: "Titel",
      children: externalWebhook?.title ?? null,
    },
    {
      label: "Methode",
      children: externalWebhook?.method ?? null,
    },
    {
      label: "Url",
      children: externalWebhook?.url ?? null,
    },
  ];

  return (
    <Card
      loading={isLoading}
      className="w-full"
      title="Externe webhook"
      extra={
        <Space>
          <Link to={`/external-webhooks/${externalWebhook?.id}/edit`}>
            <Button icon={<EditOutlined />} />
          </Link>
          <Popconfirm
            title="Externe webhook verwijderen"
            description="Weet je zeker dat je deze Externe webhook wilt verwijderen?"
            onConfirm={() => deleteMutation?.mutate()}
            okText="Ja"
            cancelText="Nee"
          >
            <Button
              loading={deleteMutation?.isPending}
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </Space>
      }
    >
      <Descriptions
        items={[
          ...items,
          ...(externalWebhook?.configuration
            ? Object.entries(externalWebhook.configuration).map(
                ([key, value]) => ({
                  key,
                  label: `Configuratie: ${key}`,
                  children: JSON.stringify(value, null, 2),
                }),
              )
            : []),
        ]}
      />
    </Card>
  );
};
